import * as common from '../../../libs/common';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {IInquiryCndsState, ICom0103MState, IBoardItemState, IUserItemState, IBoardDcdState} from '../../models/com/com0103m_model';
  
const initialState: ICom0103MState = {
    boardList: [],     // 게시글목록
    userList: [],      // 사용자 조회결과 
    boardDcdList: [],  // 게시판구분코드(카테고리)

    /* 조회조건 */
    inquiryCnds: {
        boardDcd        : '',   // 카테고리
        title           : '',   // 제목
        rgstUserNm      : '',   // 작성자
        rgstEmpNo       : '',   // 작성자
        inqryStartDt    : '',   // 시작일자
        inqryEndDt      : '',   // 종료일자         
    },

    boardDcd : '',
    relInstCd : '',
    pageSize  : 20,
    current   : 1,
    totalCnt  : 0,
}

export const com0103m_Slice = createSlice({
    name: "com0103m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            let initInquiryCnds = {
                ...initialState.inquiryCnds
            };

            if (!common.isEmptyString(state.boardDcd)) {
                initInquiryCnds = {
                    ...initInquiryCnds,
                    boardDcd : state.boardDcd
                };
            }

            Object.assign(state, {...initialState
                                   , boardDcdList: state.boardDcdList
                                   , userList: state.userList
                                   , inquiryCnds : initInquiryCnds});
        },
        setBoardList: (state, action:PayloadAction<IBoardItemState[]>) => {
            state.boardList = action.payload;
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setRelInstCd: (state, action:PayloadAction<string>) => {
            state.relInstCd = action.payload;
        },
        setBoardDcd: (state, action:PayloadAction<string>) => {
            state.boardDcd = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
        setTotalCnt: (state, action:PayloadAction<number>) => {
            state.totalCnt = action.payload;
        },
        setBoardDcdList: (state, action:PayloadAction<IBoardDcdState[]>) => {
            state.boardDcdList = action.payload;
        },
    },
});

export default com0103m_Slice.reducer;
export const Com0103mAction  = com0103m_Slice.actions;
export const Com0103mReducer = com0103m_Slice.reducer;